import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "kreform-field-ion-checkbox",
  template: `
    <ion-item>
      <ion-label [position]="to.labelPosition">
        <span *ngIf="to.required" class="required-icon">*</span>{{ to.label }}
      </ion-label>
      <ion-checkbox
        slot="end"
        mode="ios"
        [formControl]="formControl"
        [ionKreFormAttributes]="field"
        [disabled]="!editor"
      ></ion-checkbox>
    </ion-item>
  `,
})
export class KreFormFieldIonCheckbox extends FieldType {}
